module.exports = __webpack_public_path__ + "20240105162613/img/blogo.879a4b42.png";